export default __webpack_public_path__ + "static/media/text-bg-mediumt4.e67f1704.png";